export default __webpack_public_path__ + "static/media/Vector 8.ddabbb30.svg";